import { post } from '@/api/apiService.ts';
import type { CreateFeedbackRequest } from '@/types/feedback.ts';

const feedbackService = {
  create(data: CreateFeedbackRequest): Promise<void> {
    return post<CreateFeedbackRequest, void>('/api/feedback', data);
  },
};

export default feedbackService;
